import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { Moment } from 'moment/moment';

@Component({
  selector: 'app-user-information',
  imports: [TranslatePipe, NgClass],
  templateUrl: './user-information.component.html',
  styleUrl: './user-information.component.scss',
  standalone: true,
})
export class UserInformationComponent {
  @Input() label!: string;
  @Input() value!: string | string[] | Moment | Date;
  @Input() customClass?: string | string[] | { [classname: string]: boolean };

  protected readonly Array = Array;

  get statusClass(): string | string[] | { [classname: string]: boolean } {
    if (this.customClass) return this.customClass;
    if (
      typeof this.value === 'string' &&
      this.label === 'userlist.content.name'
    ) {
      return 'user-information__user-name';
    }

    let date: Date | null = null;
    if ((this.value as Moment)?.toDate) {
      date = (this.value as Moment).toDate();
    } else if (this.value instanceof Date) {
      date = this.value;
    } else if (typeof this.value === 'string') {
      date = new Date(this.value);
      if (isNaN(date.getTime())) return '';
    } else {
      return '';
    }

    const today = new Date();
    const diffTime = date.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) return 'user-information__available';
    if (diffDays <= 28) return 'user-information__available-soon';
    return 'user-information__not-available';
  }
}
